import Icon from '../components/Icon.vue'

Icon.register({
  'toggle-off': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384 64c106 0 192 86 192 192s-86 192-192 192h-192c-106 0-192-86-192-192s86-192 192-192h192zM64 256c0 70.8 57.3 128 128 128 70.8 0 128-57.3 128-128 0-70.8-57.3-128-128-128-70.8 0-128 57.3-128 128zM384 384c70.8 0 128-57.3 128-128 0-70.8-57.3-128-128-128h-48.9c65.2 72.9 65.2 183.1 0 256h48.9z'
      }
    ]
  }
})
